import type { CorporateTaxSetting } from '@libs/domain';
import { string } from '@ps-smart-cp/utils';

class CorporateTax
  implements Pick<CorporateTaxSetting['schema'], 'bookUsedAsFinanceBook' | 'bookUsedAsTaxBook'>
{
  private constructor(
    readonly bookUsedAsFinanceBook: string,
    readonly bookUsedAsTaxBook: string,
  ) {}

  static init() {
    return new CorporateTax('', '');
  }

  static fromRaw(raw: CorporateTaxRaw) {
    return new CorporateTax(
      raw.bookUsedAsFinanceBook ? raw.bookUsedAsFinanceBook.toString() : string.empty,
      raw.bookUsedAsTaxBook ? raw.bookUsedAsTaxBook.toString() : string.empty,
    );
  }
}

class CorporateTaxRaw
  implements Pick<CorporateTaxSetting['record'], 'bookUsedAsFinanceBook' | 'bookUsedAsTaxBook'>
{
  private constructor(
    readonly bookUsedAsFinanceBook: number | null,
    readonly bookUsedAsTaxBook: number | null,
  ) {}

  static fromModel(model: CorporateTax) {
    return new CorporateTaxRaw(
      model.bookUsedAsFinanceBook ? Number(model.bookUsedAsFinanceBook) : null,
      model.bookUsedAsTaxBook ? Number(model.bookUsedAsTaxBook) : null,
    );
  }
}

export { CorporateTax, CorporateTaxRaw };
